import { LabParameterGroup } from "./lab-parameter-group.model";

export class LabParameterHeader {
    labParameterHeaderId: number;
    totalItems: number;
    createdBy: number;
    modifiedBy?: number;
    parameterName: string;
    displayName: string;
    referenceOutput: string;
    createdByName: string;
    modifiedByName: string;
    createdDate: Date;
    modifiedDate?: Date;
    active: boolean;
    isLoading: boolean;
    labParameterMethodId?: number;
    methodName: string;
    text: string;
    machineId: number;
    machineParameterName: string;
    parameterGroup: Array<LabParameterGroup>;
    parameterId: string;

    constructor() {
        this.parameterGroup = new Array<LabParameterGroup>();
    }
}